import React from 'react'
import { Redirect } from 'react-router'

const LoginRedirect: React.FC = () => {
  return <Redirect to='/login'/>
}

export default LoginRedirect
